import Text from '@shared/components/content/text';
import { capitalizeFirstLetter, cn } from '@shared/lib/utils';
import React from 'react';

interface ChartLegendProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  color: string;
}

export default function ChartLegend({ name, color }: ChartLegendProps) {
  return (
    <div className="flex items-center space-x-2">
      <div
        style={{ backgroundColor: color }}
        className={cn(`size-4 rounded-sm shrink-0`)}
      ></div>
      <Text className="text-sm font-light">{capitalizeFirstLetter(name)}</Text>
    </div>
  );
}
